import { tokenAxios } from "@/utils/axios";
import { useQuery } from "@tanstack/react-query";
import { useAppState } from "@/contexts/app-state";
import { buildApiUrl } from "@/utils/api";

const getUsers = async ({ practiceId, requestedUser }: { practiceId: string, requestedUser: string}) => {
  const { data } = await tokenAxios().get<string[]>(buildApiUrl("users"), {
    params: {
      practiceId,
      requestedUser,
    },
  });
  return data;
};

export const useUsers = () => {
  const { context, loggedInUser } = useAppState();
  const practiceId = context?.athena?.practiceId ?? "8967";
  const requestedUser = loggedInUser;

  return useQuery<string[], Error>({
    queryKey: ["users"],
    queryFn: () => getUsers({ practiceId, requestedUser }),
  });
};
